<template>
	<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M9.63158 3H3V9.63158H9.63158V3Z" fill="#F25022"/>
		<path d="M9.63158 10.3684H3V17H9.63158V10.3684Z" fill="#00A4EF"/>
		<path d="M17 3H10.3684V9.63158H17V3Z" fill="#7FBA00"/>
		<path d="M17 10.3684H10.3684V17H17V10.3684Z" fill="#FFB900"/>
	</svg>
</template>

<script>
export default {
	name: "MicrosoftLogo",
};
</script>
